<template>
  <div id="app">
    <HelloWorld/>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
  font-size: 13px;
  line-height: 1.6;
  color: #404040;
}
/**
* Typography
*/
h1,h2,h3,h4,h5,h6 {
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #333;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 140%;
  margin-bottom: 0.4em;
}

h1{
  font-size: 180%;
}
h2, h3{
  font-size: 140%;
}

strong{
  font-weight: 600;
}
a:focus,
a:hover     { color: #f07800; }
a           { color: #f07800; text-decoration: underline; }
p {
  margin: 0 0 1.5em;
}
</style>
